import React from "react";
import { testimonials } from '../../../assets/data/homeData';

const TestimonialsSection = () => (
  <section className="py-16 bg-gray-50">
    <div className="max-w-7xl mx-auto px-4">
      <h2 className="text-3xl font-bold text-center mb-10">What Our Users Say</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {testimonials.map((t, idx) => {
          const names = (t.name || "").trim().split(/\s+/);
          const initials = names.length === 1
            ? names[0][0]
            : `${names[0][0]}${names[names.length - 1][0]}`;
          return (
            <div key={idx} className="bg-white rounded-lg shadow-md p-6 flex flex-col items-center text-center">
              <div
                aria-hidden="false"
                className="w-16 h-16 rounded-full mb-4 flex items-center justify-center bg-blue-100 text-blue-600 font-semibold text-lg"
              >
                {initials.toUpperCase()}
              </div>
              <p className="text-gray-700 mb-2">"{t.feedback}"</p>
              <span className="font-semibold text-blue-600">{t.name}</span>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default TestimonialsSection;
